import { createFileRoute } from '@tanstack/react-router';
import { CampaignExperimentsRoute } from './-route-wrappers';

function CampaignTestsRoute() {
  const { broadcastId } = Route.useParams();
  return <CampaignExperimentsRoute campaignId={broadcastId} campaignPath="broadcasts" />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/tests/',
)({
  component: CampaignTestsRoute,
});
